import React from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import AddSettingForm from "./Componates/AddSettingForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import feilds from "../json/SettingFeilds.json";
import { validateForm } from "utils/validation";
import { ParkingSettingRules } from "validation/ValidationRules";
import {
  Create,
  GetAllZonesTypes,
  GetAllVehicleType,
  GetAllTaxOptions,
} from "adminApi/ParkingSettingApi/ParkingSetting.js";

const AddSetting = () => {
  const navigate = useNavigate();
  const { formdata } = feilds;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  // Initialize form values
  const {
    values,
    errors,
    handleChange,
    setErrors
  } = useFormChange(
    initialValues,
    ParkingSettingRules
  );

  //Get Vehicle Type
  const {
    data: VehicleTypeOptions,
    loading: loadingVehicleTypeOptions
  } = useFetchAllData(
    GetAllVehicleType
  );

  //Get Zones Types
  const {
    data: ZonesTypesOptions,
    loading: loadingZonesTypesOptions
  } = useFetchAllData(
    GetAllZonesTypes
  );

  // Get Tax Options
  const {
    data: TaxOptions,
    loading: loadingTaxOptions
  } = useFetchAllData(
    GetAllTaxOptions
  );

  // Form submit hook
  const {
    loading: loadingSubmit,
    handleSubmit
  } = useFormSubmit(
    async (formValues) => {
      return await Create({ data: formValues });
    },
    (vals) => {
      const err = validateForm(vals, ParkingSettingRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Setting created successfully"
  );

  return (

    <>
      {(
        loadingSubmit ||
        loadingVehicleTypeOptions ||
        loadingZonesTypesOptions ||
        loadingTaxOptions
      ) && <Spinner isSpinner={true} />
      }
      <AddSettingForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Setting"
        VehicleTypeOptions={VehicleTypeOptions}
        ZonesTypesOptions={ZonesTypesOptions}
        TaxOptions={TaxOptions}
      />
    </>
  );
};

export default AddSetting;
